// =============================================================================
// Desktop date helpers — thin shim that re-exports from /shared/.
// New code: prefer the canonical names imported directly from shared/.
//
// Desktop's historical names (preserved exactly):
//   parseTs → parseTimestamp
//   timeAgo → relativeTime
// =============================================================================

import { parseTimestamp, relativeTime } from "../../../shared/dates.js";

export { parseTimestamp, relativeTime } from "../../../shared/dates.js";

/** Force-UTC parse for naive Supabase timestamps. */
export function parseTs(ts) { return parseTimestamp(ts); }

/** Relative time: "5m ago" / "3h ago" / "Mar 5". */
export function timeAgo(ts) { return relativeTime(ts); }
